<template>
  <v-card
    :class="temoignage.isActif ? 'active-card': ''"
    class="card-height"
    color="var(--kaki)"
  >
    <div class="d-flex flex-row justify-end pt-3 mr-2">
      <AgrButton
        icon
        @click="onEdit"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
      <AgrButton
        icon
        @click="onDelete"
      >
        <v-icon color="grey darken-2">
          mdi-trash-can-outline
        </v-icon>
      </AgrButton>
    </div>
    <div class="d-flex card-height80 flex-column pb-8 mx-6">
      <div class="d-flex titre-h4 w-100 mb-auto">
        "{{ temoignage.texteTemoignage }}"
      </div>
      <div class="d-flex flex-row mt-5 nom">
        <v-avatar
          v-if="temoignage.photo"
          rounded="lg"
          size="64"
        >
          <!-- on replace l'entête avant la partie chiffrée parce qu'elle seul est enregistrée dans le back -->
          <img
            :src="'data:image/jpeg;base64,'+temoignage.photo.contenu"
            alt="failed"
          >
        </v-avatar>
        <v-icon
          v-else
          size="64"
        >
          mdi-account
        </v-icon>
        <div class="d-flex flex-column justify-center ml-3">
          <div class="d-flex titre-h4 secondary--text mb-1">
            {{ temoignage.prenomAdherent }} {{ temoignage.nomAdherent }}
          </div>
          <div class="d-flex flex-row">
            <v-icon small>
              mdi-map-marker
            </v-icon>
            <div class="texte texte-gris-fonce">
              {{ temoignage.lieuExploitation }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import {AgrButton} from '@agrial/ui'

export default {
  name: 'Temoignage',
  components: {AgrButton},
  props: {
    temoignage: {
      type: Object,
      required: true
    }
  },

  methods: {
    onEdit () {
      this.$emit('edit', this.temoignage)
    },

    onDelete () {
      this.$emit('delete', this.temoignage)
    },
  }
}

</script>

<style lang="scss" scoped>
.card-height {
  height: 100%;
}

.card-height80 {
  height: 90%;
}

.avatar {
  height: 64px;
  width: 64px;
}

.nom {
  height: 80px;
}

.active-card {
  border: solid 3px var(--branche) !important;
}
</style>
